import React, { Component } from "react";

class ErrorAlert extends Component {
  state = {
    message: ""
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.message !== prevState.message) {
      return { message: nextProps.message };
    }
  }

  componentDidMount() {
    this.setState({ message: this.props.message });
  }

  handleCloseAlert = () => {
    this.props.handleResetErrorMessage();
  };

  render() {
    return this.state.message ? (
      <div
        class="alert alert-danger alert-dismissible text-left fade show"
        role="alert"
      >
        {this.state.message}
        <button
          type="button"
          class="close"
          aria-label="Close"
          onClick={this.handleCloseAlert}
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
    ) : null;
  }
}

export default ErrorAlert;
